import { render } from "./Callback.vue?vue&type=template&id=37ff6e2f"
import script from "./Callback.vue?vue&type=script&lang=ts"
export * from "./Callback.vue?vue&type=script&lang=ts"
script.render = render

export default script